// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xLoadingOverlay } from "@ces/App/Handlers/XNG/Common";
import { addToEndOfChain, addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, UnassignCartFromGuest } from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";

type HandlerType = typeof UnassignCartFromGuest;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", value: "add_account" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "remove", value: "add_account" }));
};

addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
